import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import FieldSelection from "./FieldSelection";
import FieldsTitle from "./FieldsTitle";

const useStyles = makeStyles({
  fields: {
    marginTop: 46,
  },
});

function Fields() {
  const css = useStyles();

  return (
    <div className={css.fields}>
      <FieldsTitle />
      <FieldSelection />
    </div>
  );
}

export default React.memo(Fields);
